module.exports = "<p>\n  {{'AUTH.TITLE'|translate}}\n  <button (click)=\"showMessage()\">Show message</button>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth.component.html
// module id = 567
// module chunks = 9